import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'Guía de Terrenos',
  subtitle: 'Cómo Elegir el Terreno Correcto Antes de Construir',
  desc: 'Los 8 puntos que hay que verificar antes de comprar. Orientación solar, pendiente y servicios — lo que nadie te cuenta.',
  value: '$8.900'
}, {
  num: '02',
  title: 'Guía de Terminaciones',
  subtitle: 'Las Terminaciones que Más Valor Agregan al Menor Costo',
  desc: 'Las 10 terminaciones con mayor ROI en el mercado argentino. Qué hace que una casa "se vea cara" sin serlo.',
  value: '$9.900'
}, {
  num: '03',
  title: 'El Layout Perfecto',
  subtitle: 'Distribuí los Muebles Antes de Construir la Primera Pared',
  desc: 'Los 5 principios de distribución. Medidas mínimas de cada espacio. Grilla imprimible 1:50. Checklist de 20 puntos.',
  value: '$9.900'
}, {
  num: '04',
  title: '30 Casas Modernas Argentina',
  subtitle: 'Fachadas + Renders + Distribuciones: Elegí tu Estilo en 15 Minutos',
  desc: '30 diseños modernos argentinos con render fotorrealista + ilustración técnica + distribución amueblada por cada uno.',
  value: '$12.900'
}];
export function BonusSection() {
  return <section id="bonos" className="py-20 bg-white" data-id="element-21">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-6" data-id="element-24">
            <Gift className="w-8 h-8" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-26">
            4 Bonos Estratégicos
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-27">
            Siempre incluidos en los dos packs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28">
          {bonuses.map((bonus, i) => <div key={i} className="bg-beige rounded-xl p-8 border border-beige-dark relative overflow-hidden group hover:border-gold transition-colors shadow-sm" data-id="element-29">
              <div className="flex items-start gap-6" data-id="element-30">
                <div className="text-5xl font-serif font-bold text-gold/20 group-hover:text-gold/40 transition-colors" data-id="element-31">
                  {bonus.num}
                </div>
                <div data-id="element-32">
                  <h3 className="font-bold text-xl text-charcoal mb-2" data-id="element-33">
                    {bonus.title}
                  </h3>
                  <p className="text-base font-semibold text-gold mb-3" data-id="element-34">
                    {bonus.subtitle}
                  </p>
                  <p className="text-base text-gray-600 mb-6 leading-relaxed" data-id="element-35">
                    {bonus.desc}
                  </p>
                  <div className="flex items-center gap-3 text-lg" data-id="element-36">
                    <span className="text-red-500 line-through font-medium" data-id="element-37">
                      {bonus.value}
                    </span>
                    <span className="font-bold text-gold text-xl" data-id="element-38">GRATIS</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center bg-charcoal text-white py-8 rounded-xl border border-gold shadow-lg" data-id="element-39">
          <p className="text-xl md:text-2xl font-medium" data-id="element-40">
            Valor total bonos{' '}
            <span className="line-through text-red-400 mx-3" data-id="element-41">$41.600</span>
            <span className="text-gold font-bold" data-id="element-42">→ GRATIS hoy</span>
          </p>
        </div>
      </div>
    </section>;
}